<template>
  <!-- 法律服务面对面-律师团队-律师详情 -->
  <div class="lawyer-detail">
    <h3 class="titleh3">{{form.region}}工会职工法律援助律师团队</h3>
    <div class="detailbox">
      <div class="imgbox">
        <img :src="form.photo_att_url?(BASEURL+'RESOURCE/' + form.photo_att_url):(require('@/assets/images/default-head.jpg'))" alt="" />
        <p>{{ form.name }}</p>
      </div>
      <div class="desc">
        {{ form.profile }}
      </div>
    </div>
    <div class="btn-box">
      <a-button type="primary" @click="closeDetail">关闭</a-button>
    </div>
  </div>
</template>
<script>
import { getLawyerDetail } from '@/api/lawyer.js';
export default {
  name: 'LawyerDetail',
  props: ['id'],
  data() {
    return {
      form: {},
    };
  },
  mounted() {
    this.loadLawyerDetail();
  },
  methods: {
    async loadLawyerDetail() {
      if (this.id) {
        let p = { id: this.id };
        this.form = await getLawyerDetail(p);
        console.log(this.form);
      }
    },
    closeDetail() {
      window.close();
    },
  },
};
</script>
<style scoped>
.lawyer-detail {
  padding: 20px 15px;
}
.detailbox {
  display: flex;
  width: 920px;
  margin: 0 auto;
  background: #f0f0f0;
  padding: 30px 30px 0 30px;
}
.detailbox .imgbox {
  width: 172px;
  margin-right: 30px;
}
.detailbox .imgbox img {
  width: 172px;
  height: 230px;
}
.detailbox .imgbox p {
  text-align: center;
  line-height: 40px;
  font-weight: bold;
}
.detailbox .desc {
  text-indent: 24px;
  line-height: 40px;
}
.btn-box {
  text-align: center;
  padding: 20px 0;
}
</style>
